import { createAsyncThunk } from '@reduxjs/toolkit';
import { EngagementClosingDate } from '../models/engagement-closing-date.model';

export const FetchTimelineClosingDate = createAsyncThunk(
    'closingDate/fetchForTimeline',
    async (engagementId: number, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        const response = await axios.get(
            `/api/Marketplace/Engagements/${engagementId}/ClosingDate`
        );

        if (response.status !== 200) {
            throw new Error('Failed to fetch engagement closing date');
        }

        return response.data as EngagementClosingDate;
    }
);
